<template>
  <div>
    <h4 v-if="label" class="mb-0">{{ label }}</h4>
    <v-row align="center" ref="selectDateWrapper">
      <v-col
        class="text-center"
        v-for="(item, index) in availableDates"
        :key="index"
      >
        <div class="form__customCheck">
          <input
            type="radio"
            name="dateSelect"
            :id="`date-${index}`"
            :value="item.date"
            :checked="item.label == toLabelFormat(value)"
          />
          <label
            :for="`date-${index}`"
            @click="() => handleDateSelect(item.date)"
          >
            {{ item.label }}
            <v-icon x-small>mdi-check</v-icon>
          </label>
        </div>
      </v-col>

      <v-col>
        <v-menu v-model="datePicker" :close-on-content-click="false" offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              ref="customDate"
              :class="
                `
                  block
                  grey--text
                  text--darken-1
                  form__customCheckBtn
                  ${selectedDate ? 'isActive' : ''}
                `
              "
              elevation="0"
              v-bind="attrs"
              v-on="on"
              block
            >
              {{ dateLabel ? dateLabel : moreOptionsLabel }}
              <v-icon x-small>mdi-check</v-icon>
            </v-btn>
          </template>
          <div class="customDate">
            <v-date-picker
              @change="handleDateSelectByCalendar"
              :min="minDate"
              v-model="selectedDate"
              :locale="localeLanguage"
              scrollable
              no-title
            />
          </div>
        </v-menu>
      </v-col>
    </v-row>
    <!-- validationState is inhirited from v-input I believe -->
    <VMessages
      :value="errorBucket"
      color="error"
      v-if="validationState && !dateTimeMode"
    />
  </div>
</template>

<script>
import moment from 'moment'
import VInput from 'vuetify/lib/components/VInput/VInput.js'
import { mapGetters, mapActions } from 'vuex'

const DAY_AND_MONTH_FORMAT = 'DD/MM'
const DATE_ONLY_FORMAT = 'YYYY-MM-DD'

export default {
  name: 'HDatePicker',
  extends: VInput,
  props: ['value', 'dateTimeMode'],
  data() {
    return {
      dateLabel: null,
      selectedDate: null,
      startDate: moment(),
      endDate: moment(this.startDate).add(4, 'days'),
      minDate: moment().toISOString(),
      availableDates: [],
      datePicker: false,
      startDateDelay: null,
      moreOptionsLabel: this.$t('filters.datePicker.more'),
    }
  },

  mounted() {
    this.initPreferredDates()
    this.$nextTick(function() {
      this.initDate()
    })
  },

  computed: {
    localeLanguage() {
      return localStorage.getItem('user_language') ?? 'pt-BR'
    },
  },

  methods: {

    initDate() {
      var currentDateIsBetweenSuggestions = this.availableDates.find(
        (date) => date.label == this.toLabelFormat(this.value)
      )
      if (!currentDateIsBetweenSuggestions && this.value) {
        this.selectedDate = this.value
        this.dateLabel = this.toLabelFormat(this.value)
      }
    },

    initPreferredDates() {
      this.$nextTick(() => {
        for (
          let date = this.startDate;
          date.isBefore(this.endDate);
          date.add(1, 'days')
        ) {
          this.availableDates.push({
            date: date.toISOString(),
            label: date.format(DAY_AND_MONTH_FORMAT),
          })
        }
      })
    },

    handleDateSelect(value) {
      this.selectedDate = null
      this.dateLabel = this.moreOptionsLabel
      this.$emit('input', moment(value).format(DATE_ONLY_FORMAT))
    },

    toLabelFormat(dateString) {
      return moment(dateString).format(DAY_AND_MONTH_FORMAT)
    },

    handleDateSelectByCalendar() {
      this.dateLabel = this.toLabelFormat(this.selectedDate)
      this.$emit('input', this.selectedDate)
    },

    resetValue() {
      this.selectedDate = null
      this.dateLabel = this.moreOptionsLabel
    },
  },
}
</script>

<style>
.customDate {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
}
</style>
